import { Product } from '@spartacus/core';

export enum FLU_CHECKOUT_TYPE {
  DIRECT = 'direct',
  INDIRECT = 'indirect',
}

export interface InfluenzaContactInfo {
  email?: string;
  firstName?: string;
  fluContactId?: string;
  lastName?: string;
  phoneNo?: string;
}
export interface ActiveSeasons {
  code: string;
  endDate: string;
  isHospital: boolean;
  products: Product[];
  startDate: string;
  asmReserveOnly?: boolean;
}

export const QUOTE_OPEN_STATUSES = ['BUYER_DRAFT'];
